/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { templatesCreate } from "../funcs/templatesCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CreatePromptTemplateResult } from "../models/components/createprompttemplateresult.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateTemplateRequest,
  CreateTemplateSecurity,
} from "../models/operations/createtemplate.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateTemplateMutationVariables = {
  request: CreateTemplateRequest;
  security?: CreateTemplateSecurity | undefined;
  options?: RequestOptions;
};

export type CreateTemplateMutationData = CreatePromptTemplateResult;

export type CreateTemplateMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createTemplate templates
 *
 * @remarks
 * Create a new prompt template.
 */
export function useCreateTemplateMutation(
  options?: MutationHookOptions<
    CreateTemplateMutationData,
    CreateTemplateMutationError,
    CreateTemplateMutationVariables
  >,
): UseMutationResult<
  CreateTemplateMutationData,
  CreateTemplateMutationError,
  CreateTemplateMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateTemplateMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateTemplate(): MutationKey {
  return ["@gram/client", "templates", "create"];
}

export function buildCreateTemplateMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateTemplateMutationVariables,
  ) => Promise<CreateTemplateMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateTemplate(),
    mutationFn: function createTemplateMutationFn({
      request,
      security,
      options,
    }): Promise<CreateTemplateMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(templatesCreate(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
